module.exports = __webpack_public_path__ + "static/media/ChefManjitGill.d13e451f.png";